import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { IntersectionSubscriber } from 'sb-intersection-observer'
import cx from 'classnames'

import imageSizes from 'decorators/imageSizes'

import PlaceholderImage from 'components/ui/PlaceholderImage/PlaceholderImage'

import s from './LazyImage.scss'


class LazyImage extends PureComponent {

  static propTypes = {
    className: PropTypes.string,
    src: PropTypes.string,
    alt: PropTypes.string,
    itemProp: PropTypes.string,
    withIntersector: PropTypes.bool,
  }

  isIntersected = false
  figureNode = null
  placeholderNode = null

  state = {
    isError: false,
  }

  init = (figureNode) => {
    const { withIntersector } = this.props

    if (figureNode && !this.figureNode) {
      this.figureNode = figureNode
      this.placeholderNode = figureNode.childNodes[0] // eslint-disable-line

      if (!withIntersector || this.isIntersected) {
        this.load()
      }
    }
  }

  load() {
    const { src, srcSet, alt } = this.props

    const img = new Image()

    img.onload = () => {
      this.figureNode.appendChild(img)
      this.placeholderNode.classList.add(s.hidden)
    }

    img.onerror = () => {
      this.setState({
        isError: true,
      })
    }

    img.alt = alt
    img.src = src
    img.srcset = srcSet
  }

  handleIntersect = () => {
    this.isIntersected = true

    if (this.figureNode) {
      this.load()
    }
  }

  render() {
    const { className, src, alt, itemProp, withIntersector } = this.props
    const { isError } = this.state

    const image = (
      <figure ref={this.init} className={cx(className, s.container)}>
        {
          isError ? (
            <PlaceholderImage className={s.placeholderImage} alt={alt} />
          ) : (
            <img className={s.placeholder} src={`${src}&placeholder=1`} alt={alt} itemProp={itemProp} />
          )
        }
      </figure>
    )

    if (withIntersector) {
      return (
        <IntersectionSubscriber onceIntersect={this.handleIntersect}>
          {image}
        </IntersectionSubscriber>
      )
    }

    return image
  }
}


export default imageSizes({ lambda: true })(LazyImage)
